import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import pathify from 'vuex-pathify';

import { axios } from '@/plugins/axios';
import router from '@/router';
import { authStorePlugin } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import AltoleapAccounts from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';

import { accounting } from './accounting';
import { currencyNew } from './currency';
import data from './data';
import { department } from './department';
import { document } from './document';
import { employee } from './employee';
import { employeeForm } from './employee-form';
import { employeeTimeOff } from './employee-timeoff';
import { hrDepartment } from './hr-department';
import { invoice } from './invoice';
import { item } from './item';
import { itemTag } from './item-tag';
import { itemCommercialTranslation } from './itemcommercialtranslation';
import { maintenance } from './maintenance';
import modules from './modules';
import { overtimeRequest } from './overtime-request';
import { inventoryAdvancePayment } from './inventory-advance-payment';
import { payrollChangeRequest } from './payrollchangerequest';
import refreshPlugin from './plugins/refresh';
import { priceSnapshot } from './pricesnapshot';
import { order } from './order';
import { quote } from './quote';
import { quotePaymentTermCode } from './quote-payment-term-code';
import { quoteServiceVariable } from './quote-service-variable';
import { quoteTemplate } from './quotetemplate';
import { requisition } from './requisition';
import { salesRep } from './sales-rep';
import { IRootState } from './store.types';
import { timeOff } from './timeoff';
import { timeOffRequest } from './timeoff-request';
import { timeOffCalendar } from './timeoff-calendar';
import { vendor } from './vendor';
import { workgroup } from './workgroup';
import { employeeWorkgroup } from './employee-workgroup';
import { vacationCarryOverRequest } from './vacation-carry-over-request';
import { contract } from './contract';
import { workflow } from './workflow';
import { paymentPlan } from './payment-plan';
import { tariff } from './tariff';
import { microsoftAuth } from './microsoft-auth';

// plugins
import { sentryStorePlugin } from './plugins/sentry-plugin';
import { sentryAxiosStorePlugin } from './plugins/sentry-axios';
import { formTemplate } from './form-template';
import { paymentRequisition } from './payment-requisition';
import { workflowFormTemplate } from './workflow-form-template';
import { workflowForm } from './workflow-form';

Vue.use(Vuex);

export const makeStore = (): Store<IRootState> =>
  new Vuex.Store<IRootState>({
    state: {
      version: 1
    },

    mutations: {},
    actions: {},
    getters: {},

    // TODO: Uncomment out below modules
    modules: {
      ...modules,
      ...data,
      ...AltoleapAccounts.storeModules(axios),
      accounting,
      timeOffCalendar,
      contract,
      currencyNew,
      department,
      document,
      employee,
      employeeForm,
      employeeTimeOff,
      employeeWorkgroup,
      formTemplate,
      invoice,
      item,
      itemCommercialTranslation,
      microsoftAuth,
      overtimeRequest,
      paymentPlan,
      priceSnapshot,
      order,
      quote,
      quoteTemplate,
      quotePaymentTermCode,
      quoteServiceVariable,
      inventoryAdvancePayment,
      paymentRequisition,
      payrollChangeRequest,
      requisition,
      salesRep,
      tariff,
      timeOff,
      timeOffRequest,
      itemTag,
      vendor,
      vacationCarryOverRequest,
      workgroup,
      hrDepartment,
      maintenance,
      workflow,
      workflowForm,
      workflowFormTemplate
    },

    plugins: [
      pathify.plugin,
      refreshPlugin,
      authStorePlugin(axios, router),
      sentryStorePlugin,
      sentryAxiosStorePlugin
    ]
  });
